export class ConvertDate {
    public ConvertFromEpochString(epochString: string) {
        if (!epochString || epochString === '') {
            return null;
        }

        let epochNumber = parseInt(epochString);
        return this.ConvertFromEpochNumber(epochNumber);
    }

    public ConvertFromEpochNumber(epochNumber: number) {
        let dateTime = new Date(0);
        dateTime.setUTCSeconds(epochNumber);
        return dateTime.toUTCString();
    }
}